export const ROUTES = {
    auth: {
        root: "/",
        signin: "/signin",
        signup: "/signup",
        forgotPassword: "/forgot-password",
    },
    account: {
        account: "/account",
    },
};
